// extracted by mini-css-extract-plugin
module.exports = {"tableGrid":"styles_tableGrid__18CXi","col":"styles_col__3GVPD"};